<template>
  <div class="manufacturerslist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('xl')">
        <el-col :span="12">
          <el-form-item :label="$t('manage.name65')" prop="tenantName">
            <el-input v-model="queryInfo.tenantName" :placeholder="$t('public.name5')" :style="$i18n.locale === 'en' ? 'width:360px' : ''" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select :key="'mfr-status-' + $i18n.locale" v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getPageList" v-if="buttonPerms.indexOf('tenant/list') > -1" >{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addVendor(null)" v-if="buttonPerms.indexOf('tenant/add') > -1">{{ $t('manage.name74') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name66')" prop="tenantCode" sortable></el-table-column>
      <el-table-column :label="$t('manage.name67')" prop="tenantName" sortable align="left" header-align="left"></el-table-column>
      <el-table-column :label="$t('manage.name68')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name69')" prop="orderNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(1, scope.row)">{{ scope.row.orderNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name70')" prop="modelNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(2, scope.row)">{{ scope.row.modelNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name71')" prop="merchantNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(3, scope.row)">{{ scope.row.merchantNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name72')" prop="contactWay" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <el-switch :value="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="goManufacturerUserList(scope.row)">{{ $t('manage.name73') }}</el-button>
          <el-button type="text" @click="addVendor(scope.row)" v-if="buttonPerms.indexOf('tenant/edit') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delVendor(scope.row)" v-if="buttonPerms.indexOf('tenant/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
          <el-button type="text" @click="configurationVendor(scope.row)" v-if="buttonPerms.indexOf('tenant/configuration') > -1">{{ $t('bike.name533') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog width="400px" :title="vendorInfo.tenantId === '' ? $t('manage.name97') : $t('manage.name98')" v-if="vendorInfoDialog" :visible.sync="vendorInfoDialog" :before-close="close">
      <el-form ref="vendorFormRef" :model="vendorInfo" :rules="vendorInfoRules" :label-width="formLabelWidth('xl')">
        <el-form-item prop="tenantName" :label="$t('manage.name65')">
          <el-input v-model="vendorInfo.tenantName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="tenantCode" :label="$t('manage.name75')">
          <el-input v-model="vendorInfo.tenantCode" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="contactName" :label="$t('manage.name76')">
          <el-input v-model="vendorInfo.contactName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="contactWay" :label="$t('manage.name77')">
          <el-input v-model="vendorInfo.contactWay" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="remark" :label="$t('manage.name78')">
          <el-input v-model="vendorInfo.remark" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>

        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="vendorInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { tenantList, tenantAdd, tenantEdit, tenantDelete, tenantStatus } from '@/api/manage.js'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    statusOptions() {
      return [
        {
          value: 2,
          label: this.$t('operate.name98')
        },
        {
          value: 0,
          label: this.$t('operate.name48')
        },
        {
          value: 1,
          label: this.$t('operate.name39')
        }
      ]
    }
  },
  data() {
    return {
      loginstatus: 1,
      queryInfo: {
        tenantName: '',
        status: 2,
        page: 1,
        limit: 10
      },
      tableList: [],
      total: 0,
      selectList: [],
      tableLoading: false,
      loading: false,
      vendorInfoRules: {
        tenantName: [
          {
            required: true,
            message: this.$t('screen.name15'),
            trigger: 'blur'
          }
        ]
      },
      vendorInfo: {
        tenantName: '',
        tenantId: '',
        tenantCode: '',
        contactWay: '',
        contactName: '',
        tenantType: 1,
        remark: '',
        status: true
      },
      showMsgVisible: false,
      rolesInfo: {
        roles: ''
      },
      vendorInfoDialog: false,
      buttonPerms: ''
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.queryList()
  },
  methods: {
    addVendor(row) {
      if (row !== null) {
        this.vendorInfo = {
          tenantName: row.tenantName,
          tenantId: row.tenantId,
          tenantCode: row.tenantCode,
          contactWay: row.contactWay,
          contactName: row.contactName,
          tenantType: 1,
          remark: row.remark,
          status: row.status
        }
      }
      this.vendorInfoDialog = true
    },
    configurationVendor (row) {
       this.$router.push({ path: '/smsConfiguration', query: { tenantId: row.tenantId } })
    },
    close() {
      this.vendorInfoDialog = false
      this.vendorInfo = {
        tenantName: '',
        tenantId: '',
        tenantType: 1,
        tenantCode: '',
        contactWay: '',
        contactName: '',
        remark: '',
        status: true
      }
    },
    submitForm() {
      this.$refs.vendorFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (this.vendorInfo.tenantId === '') {
          tenantAdd(this.vendorInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          tenantEdit(this.vendorInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    resetQueryInfo() {
      this.queryInfo = {
        tenantName: '',
        status: 2,
        page: 1,
        limit: 10
      }
      this.queryList()
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 1
      }
      if (this.queryInfo.tenantName) {
        data.tenantName = this.queryInfo.tenantName.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      tenantList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    delVendor(row) {
      this.$confirm(this.$t('screen.name16'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          tenantDelete({ tenantId: row.tenantId })
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    changeSwitch(row, e) {
      const tip = row.status ? this.$t('screen.name17') : this.$t('screen.name18')
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.tableLoading = true
          tenantStatus({ tenantId: row.tenantId })
            .then((res) => {
              this.tableLoading = false
              this.queryList()
            })
            .catch(() => {
              this.tableLoading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    cellClick(type, row) {
      console.log('row==', row)
      if (type === 1) {
      }

      if (type === 2) {
      }

      if (type === 3) {
      }
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    },
    goManufacturerUserList(row) {
      this.$router.push({ path: '/manufactureruserlist', query: { tenantId: row.tenantId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.manufacturerslist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;

    // Keep controls flush after labels; space between search items (Permissions-like)
    ::v-deep .el-form-item__label {
      width: auto !important;
      padding-right: 8px;
      justify-content: flex-start !important;
      text-align: left !important;
    }

    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }

    ::v-deep .el-col {
      padding-right: 32px;
      box-sizing: border-box;
    }

    ::v-deep .el-col:last-child {
      padding-right: 0;
    }
  }

  .click-pointer {
    cursor: pointer;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
